import NewReleasesIcon from "@mui/icons-material/NewReleases";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import FigmaLinkIcon from "../../../components/icons/FigmaIcon";
import { AutologIcon } from "../../sidebar/icons/AutologIcon";
import {
  AllCrewIcon,
  ConfigurationIcon,
  ContactIcon,
  DashboardIcon,
  EndpointRequestIcon,
  OperationsIcon,
  UserAdminIcon,
} from "../../sidebar/icons";
import { DocumentIcon } from "../../../components/icons";
import { BugReport, GridViewOutlined } from "@mui/icons-material";
import { SvgIconProps } from "@mui/material";

export type AppItem = {
  label: string;
  icon: React.ComponentType<SvgIconProps>;
  route?: string;
  action?: "OPEN_TOOLS_DRAWER";
  color: string; 
};

export const apps: AppItem[] = [
  {
    label: "Dashboard",
    icon: DashboardIcon,
    route: "/Dashboard",
    color: "#4FD1C5",
  },
  {
    label: "Bookings",
    icon: DocumentIcon,
    route: "/bookings/funeral",
    color: "#4FD1C5",
  },
  {
    label: "Contacts",
    icon: ContactIcon,
    route: "/contacts",
    color: "#63B3ED",
  },
  {
    label: "Venues",
    icon: ContactIcon,
    route: "/venues",
    color: "#718096",
  },
  {
    label: "All Crew",
    icon: AllCrewIcon,
    route: "/crew-management/all-crew",
    color: "#F6AD55",
  },
  {
    label: "Streams",
    icon: OperationsIcon,
    route: "/stream-management",
    color: "#4299E1",
  },
  {
    label: "Requested Quotes",
    icon: DocumentIcon,
    route: "/request-for-quote",
    color: "#ED64A6",
  },
  {
    label: "Memorial Pages",
    icon: DocumentIcon,
    route: "/client-portal-dashboard",
    color: "#48BB78",
  },
  {
    label: "Proposal",
    icon: DocumentIcon,
    route: "/proposals",
    color: "#F687B3",
  },
  {
    label: "Figma Designs",
    icon: FigmaLinkIcon,
    route: "/figma-designs",
    color: "#9F7AEA",
  },
  {
    label: "Tool and Assets",
    icon: GridViewOutlined,
    action: "OPEN_TOOLS_DRAWER" as const,
    color: "#10B981",
  },
  {
    label: "Autolog",
    icon: AutologIcon,
    route: "/autolog",
    color: "#FC8181",
  },
  {
    label: "Settings",
    icon: SettingsOutlinedIcon,
    route: "/settings",
    color: "#38B2AC",
  },
  {
    label: "Configurations",
    icon: ConfigurationIcon,
    route: "/configurations",
    color: "#ED8936",
  },
  {
    label: "User Admin",
    icon: UserAdminIcon,
    route: "/user-management",
    color: "#667EEA",
  },
  {
    label: "Endpoint Request",
    icon: EndpointRequestIcon,
    route: "/endpoint-requests",
    color: "#D53F8C",
  },
  {
    label: "What's New",
    icon: NewReleasesIcon,
    route: "/changelog",
    color: "#4A5568",
  },
  {
    label: "Bug Reports",
    icon: BugReport,
    route: "/bug-reports",
    color: "#e60707",
  },
];
